import golfToEid from 'golf-to-eid';

//
// Define the breakpoints the manifest need to listen to.
//
const breakpoints = [
  'mobile',
  'phablet',
  'tablet',
  'desktop',
  'large'
];

//
// Golf translation ids.
//
const golf = {
  login: 'PC:AppHeader:Header:Login',
  logout: 'PC:AppHeader:Header:Logout',
  contactUs: 'Shared:UtilityBar:SupportPhone:ContactUs',
  contactUs247: 'Shared:UtilityBar:SupportPhone:ContactUs247',
  helpCenter: 'Shared:UtilityBar:SupportPhone:HelpCenter'
};

//
// Generate Traffic2 eid's to be used to track clicks. Map the generated
// strings back to the same keys the Golf translations strings have.
//
const eids = Object.keys(golf).reduce((acc, key) => {
  acc[key] = golfToEid(golf[key], {
    prefix: 'uxp.hyd.help_header',
    postfix: 'link.click'
  });
  return acc;
}, {});

export {
  breakpoints,
  golf,
  eids
};
